import { parseResponse, requestAuthAdmin } from './auth';

const DIRECTORY_PATH = '/api-admin/v0/admin-directory';

export async function listAdminDirectory(accessToken, search = '', limit = 20) {
  const params = new URLSearchParams({ limit: String(limit) });
  const normalized = String(search || '').trim();
  if (normalized) params.set('search', normalized);
  const res = await requestAuthAdmin(`${DIRECTORY_PATH}?${params}`, { method: 'GET' }, accessToken);
  const body = await parseResponse(res, DIRECTORY_PATH);
  return body?.data ?? { items: [] };
}

export async function getAdminDirectoryUser(userId, accessToken) {
  const params = new URLSearchParams({ user_id: String(userId) });
  const res = await requestAuthAdmin(`${DIRECTORY_PATH}?${params}`, { method: 'GET' }, accessToken);
  const body = await parseResponse(res, DIRECTORY_PATH);
  return body?.data ?? null;
}

export async function getAdminDirectoryUsersByIds(userIds, accessToken) {
  const unique = [...new Set((userIds || []).map(Number).filter((id) => Number.isFinite(id) && id > 0))];
  const result = {};
  const chunkSize = 8;
  for (let index = 0; index < unique.length; index += chunkSize) {
    const ids = unique.slice(index, index + chunkSize);
    const users = await Promise.all(ids.map((id) => getAdminDirectoryUser(id, accessToken).catch(() => null)));
    users.forEach((user, offset) => {
      if (user) result[ids[offset]] = user;
    });
  }
  return result;
}
